import Logo from "../../Components/Logo";
import styles from "./index.module.css";
import { Greetings, Pending, Failed } from "./Greetings";
import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import UserContext from "../../store/UserStore/context";
import useOrderStatus, { ORDER_STATUS } from "./useOrderStatus";

const screens = {
  [ORDER_STATUS.paid]: Greetings,
  [ORDER_STATUS.failed]: Failed,
  [ORDER_STATUS.pending]: Pending,
};

export default function SPaymentWIdget() {
  const context = useContext(UserContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // The store is in-memory, so coming back from the provider's checkout lands
  // here with nothing in it — then the email comes from the redirect URL.
  const email = searchParams.get("email") || context.store.user?.email;
  const status = useOrderStatus(
    email,
    context.store.user?.isPaid ? ORDER_STATUS.paid : ORDER_STATUS.pending,
  );
  const Screen = screens[status];
  // Set by PaymentStage for "оплата частинами": the confirmation happens in the
  // monobank app, so the waiting screen has to say what the client must do.
  const awaitingApp = searchParams.get("confirm") === "app";

  useEffect(() => {
    document.body.style.padding = "0";
    document.body.style.margin = "0";
    document.body.style.backgroundColor = "#0A2294";
    return () => {
      document.body.style.padding = "0";
      document.body.style.backgroundColor = "#EAF0F1";
    };
  }, []);

  useEffect(() => {
    if (!email) navigate("/");
  }, [email, navigate]);

  return (
    <div className={styles.container}>
      <Logo white />
      <div className={styles.content}>
        <div className={styles.greetings}>
          <Screen awaitingApp={awaitingApp} />
        </div>
      </div>
    </div>
  );
}
